import { ArrowRight } from "@phosphor-icons/react";

type Props = {
	onNext: () => void;
};

const DocumentsCompletedScreen = ({ onNext }: Props) => {
	return (
		<div className="h-dvh overflow-y-hidden bg-white flex flex-col items-center justify-center px-6 text-center">
			<div className="mb-8">
				<img
					src="https://stampmyvisa-public.s3.ap-south-1.amazonaws.com/biz-share-questionnaire/sun.png"
					alt="Documents Completed"
					className="w-44 h-44"
				/>
			</div>

			<h1 className="text-xl font-semibold text-gray-900 mb-3">You have completed uploading all the documents</h1>

			<p className="text-sm text-gray-500 mb-8 max-w-xs">
				Fill and verify the forms which are to be submitted to the embassy
			</p>
			<button
				onClick={onNext}
				className="
					w-full max-w-sm
					bg-gradient-to-b from-[#4E45C4] to-[#3730A3]
					shadow-[0_0_0_1.2px_#4E45C4]
					text-white
					rounded-xl
					py-3
					font-medium
					flex items-center justify-center gap-2
					transition-all duration-200
					active:scale-[0.98]
				">
				Finish Visa Form
				<ArrowRight size={18} />
			</button>
		</div>
	);
};

export default DocumentsCompletedScreen;

